var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 15.995926856994629,
    height: 16,
    viewBox: "0 0 15.995926856994629 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_25_5783"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 15.995926856994629,
    height: 16,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_25_5783)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.607461214752197,2.276441L7.994551214752197,6.66391L12.382391214752197,2.276441C12.750991214752197,1.9078529,13.348591214752197,1.9078529,13.717191214752198,2.276441C14.085791214752197,2.645029,14.085791214752197,3.24263,13.717191214752198,3.6112200000000003L9.329331214752198,7.99831L13.717191214752198,12.3862C14.088391214752198,12.7543,14.089691214752197,13.3541,13.719891214752197,13.7237C13.350191214752197,14.0933,12.750391214752197,14.0919,12.382391214752197,13.7206L7.994551214752197,9.333079999999999L3.607461214752197,13.7206C3.2371712147521974,14.0782,2.6485832147521973,14.0731,2.2845682147521975,13.709C1.9205533147521971,13.345,1.9154345147521972,12.7564,2.273064214752197,12.3862L6.660161214752197,7.99831L2.273064214752197,3.6112200000000003C1.9072347147521973,3.24226,1.9084586147521974,2.647002,2.2758012147521973,2.279555C2.6431442147521973,1.9121086,3.238401214752197,1.9107165,3.607461214752197,2.276441Z",
    fill: "#192038",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.10e6f33e1f167456fc622fe9ecbc4ac1.svg";
export { ForwardRef as ReactComponent };